var _rect, _rect2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyScenariosSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 64,
    viewBox: "0 0 800 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 9,
    width: 252,
    height: 12,
    rx: 6,
    fill: "#F1F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 45,
    width: 133,
    height: 12,
    rx: 6,
    fill: "#F1F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12429_268630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 747,
    y: 5,
    width: 33.3333,
    height: 20,
    rx: 10,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12429_268630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 762.516,
    y: 7.22266,
    width: 15.5556,
    height: 15.5556,
    rx: 7.77778,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12429_268630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 747,
    y: 41,
    width: 33.3333,
    height: 20,
    rx: 10,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12429_268630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 762.516,
    y: 43.2227,
    width: 15.5556,
    height: 15.5556,
    rx: 7.77778,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12429_268630",
    x: 760.254,
    y: 4.96075,
    width: 20.0795,
    height: 20.0785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.13095
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12429_268630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12429_268630",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12429_268630",
    x: 760.254,
    y: 40.9608,
    width: 20.0795,
    height: 20.0785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.13095
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12429_268630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12429_268630",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12429_268630"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 747,
    y: 5,
    width: 33.3333,
    height: 20,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12429_268630"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 747,
    y: 41,
    width: 33.3333,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyScenariosSkeleton);
export default __webpack_public_path__ + "static/media/empty-scenarios-skeleton.25228e30a447c89c3689b3f064fceec2.svg";
export { ForwardRef as ReactComponent };